export const formatUserStatus = (status: string | undefined, identityVerified?: boolean): string => {
  switch (status) {
    case 'archived':
      return 'Archived';
    case 'pending':
      return 'Pending';
    case 'accepted':
      if (identityVerified) return 'Confirmed & Verified';
      else return 'Confirmed';
    default:
      return '--';
  }
};
